import { render, staticRenderFns } from "./advantagesDetail.vue?vue&type=template&id=6f553991&scoped=true&"
import script from "./advantagesDetail.vue?vue&type=script&lang=js&"
export * from "./advantagesDetail.vue?vue&type=script&lang=js&"
import style0 from "./advantagesDetail.vue?vue&type=style&index=0&id=6f553991&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f553991",
  null
  
)

export default component.exports